import { adjustColorForContrast } from '../shared/helpers/colorHelper.js';

// The help center always renders in light mode, so contrast is checked against white.
export const setPortalHoverColor = () => {
  const portalColor = window.portalConfig.portalColor;
  const hoverColor = adjustColorForContrast(portalColor, 'white');

  // Set hover color for border and text dynamically
  document.documentElement.style.setProperty(
    '--dynamic-hover-color',
    hoverColor
  );
};
